import classNames from 'classnames';
import React from 'react';
import EfLink from '../ef-link';
import './index.scss';

interface EfXCoreProps {
    /**
     * 标题(图标)
     *
     * x-core 默认图标为 https://websiteoss.ecoflow.com/upload/image/1722326378837/X-core.png
     */
    title?: React.ReactNode;
    /**
     * 描述
     */
    desc?: React.ReactNode;
    /**
     * 按钮链接
     */
    btnLink?: string;
    /**
     * 按钮文案
     */
    btnText?: string;
    /**
     * 样式名
     */
    className?: string;
    /**
     * 样式名
     */
    gtm_dataLayer?: any[];
}

/**
 * 维护:谢保林
 *
 * X-Core
 */
const EfXCore: React.FC<EfXCoreProps> = ({
    title,
    desc,

    btnLink,
    btnText,
    className,
    gtm_dataLayer,
}) => {
    const prefixCls = `ef-x-core`;
    const classes = classNames(prefixCls, 'ef-container', {
        [`${className}`]: className,
    });
    const dataLayer = gtm_dataLayer || [
        {
            event: 'uaEvent',
            event_name: 'activity_preview',
            button_name: btnText,
        },
    ];
    return (
        <div className={classes}>
            <div className={`${prefixCls}-in`}>
                {title && <div className={`${prefixCls}-title`}>{title}</div>}
                {desc && <div className={`${prefixCls}-desc`}>{desc}</div>}
                <div className={`${prefixCls}-btn-box`}>
                    {btnLink && btnText && (
                        <EfLink href={btnLink} className={`${prefixCls}-btn`} dataLayer={dataLayer}>
                            {btnText}
                        </EfLink>
                    )}
                </div>
            </div>
        </div>
    );
};

export default EfXCore;
